export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpen');
    },
    openAdditionalForm({commit}) {
        commit('setAdditionalFormOpen');
    },
    closeForm({commit}) {
        commit('setFormClose');
    },
    closeAdditionalForm({commit}) {
        commit('setAdditionalFormClose');
    },

}
